var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-5 flex",attrs:{"fluid":""}},[_c('UnderConstruction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }